import { Injectable, OnDestroy } from '@angular/core';
import { Observable, defer } from 'rxjs';
import { MmDbService } from '../../mm-db/mm-db-service';
import { MmDbCollections } from '../../mm-db/mm-db-schema';

@Injectable()
export class PersonalizationService implements OnDestroy {

  constructor(private readonly mmDbService: MmDbService) {

  }

  ngOnDestroy(): void {
  }

  async setProjectValue(mydocmaProjectId: string, key: string, value: any): Promise<any> {
    return this.setValue(`${mydocmaProjectId}.${key}`, value);
  }

  async getProjectValue(mydocmaProjectId: string, key: string): Promise<any> {
    return this.getValue(`${mydocmaProjectId}.${key}`);
  }


  async deleteValue(key: string): Promise<any> {
    const db = await this.mmDbService.getDb();
    await db.remove(MmDbCollections.personalization as never, key);
  }

  async setValue(key: string, value: any): Promise<any> {
    const db = await this.mmDbService.getDb();
    const savedValue = await db.set(MmDbCollections.personalization as never, value, key);
    return savedValue;
  }

  async getValue(key: string): Promise<any> {
    const db = await this.mmDbService.getDb();
    const value = await db.get(MmDbCollections.personalization as never, key);
    return value;
  }
}
